/* ARRAY - "reward waiting" note in the cart drawer, on EVERY page. 29 Sep 2026.
   Loaded from snippets/scripts.liquid.

   A reward code applied on the rewards page stays on the cart even while the bag is empty (Shopify
   keeps it, applicable:false, until something is added). Without this, only the rewards page said so;
   everywhere else the drawer just read "Your cart is empty". Now, when the bag is EMPTY and a known
   reward code is on the cart, the drawer shows:
     "$10 off is waiting. Add any product and it comes off automatically."
   Codes: ARRAY100/200/300/500/750 = $3/$6/$10/$18/$30 off; FRIEND-* and THANKS-* = 10% off.
   Same markup and class (.rt-dnote) as the rewards page's own note (beyondads-rewards-cart.js), so on
   that page the two never double up - whichever runs first wins, the other sees it and stops.
   Styles are inline because the rewards stylesheet only loads on the rewards page.
   The drawer re-renders on every cart change, so a MutationObserver puts the note back. */
(function () {
  'use strict';
  if (window.__bqNote) return;
  window.__bqNote = true;

  var MONEY = { ARRAY100: 3, ARRAY200: 6, ARRAY300: 10, ARRAY500: 18, ARRAY750: 30 };
  var cart = null;

  function what(c) {
    if (!c || c.item_count > 0) return null;
    var codes = (c.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    for (var i = 0; i < codes.length; i++) {
      if (MONEY[codes[i]]) return '$' + MONEY[codes[i]] + ' off';
    }
    for (i = 0; i < codes.length; i++) {
      if (/^(FRIEND|THANKS)-/.test(codes[i])) return '10% off';
    }
    return null;
  }

  function paint() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var label = what(cart), el = drawer.querySelector('.rt-dnote');
    if (!label) { if (el) el.remove(); return; }
    var host = drawer.querySelector('dialog .cart-drawer__content');
    if (!host) return;
    /* the rewards page writes data-v="10" (the amount only); read both forms */
    if (el && host.contains(el)) {
      var have = el.getAttribute('data-v') || '';
      if (have === label || '$' + have + ' off' === label) return;
      el.remove();
    }
    el = document.createElement('div');
    el.className = 'rt-dnote';
    el.setAttribute('data-v', label);
    el.setAttribute('role', 'status');
    el.style.cssText = 'margin:14px 20px 18px;padding:14px 16px;border:1px dashed #D9C3C6;border-radius:12px;' +
      'background:#FBF5F4;color:#1C1A19;font-size:13.5px;line-height:1.55;text-align:left';
    el.innerHTML = '<b style="font-weight:inherit;color:#7A2340">' + label + ' is waiting.</b> Add any product and it comes off automatically.';
    var h = host.querySelector('.cart-drawer__heading');
    if (h && h.nextSibling) host.insertBefore(el, h.nextSibling); else host.insertBefore(el, host.firstChild);
  }

  var t = null;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; paint(); })
        .catch(function () {});
    }, 200);
  }

  function boot() {
    refresh();
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (what(cart) && !drawer.querySelector('.rt-dnote')) paint();
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  document.addEventListener('cart:update', refresh);
  document.addEventListener('discount:update', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
